/* eslint-disable */
export default {
  _linotte_bold: 'linotte-bold',
  _linotte_heavy: 'linotte-heavy',
}